import { getCitationRefNode } from 'src/researcher/utils';
import QuillEditor, { QuillEditorIDS } from 'src/_common/handlers/quillEditor';
import { setCurrentCursorPosition } from 'src/grammar-checker/utils';
import { CitationData, CitationStylesEnum, CitedData } from 'src/citation-generator/types';
import { citationsRichText } from 'src/citation-generator/components/CitationElement';

export function higlightCitationRefNodes(
  refNo: string,
  citationStyle: CitationStylesEnum | string
) {
  const nodes = document.querySelectorAll(`[data-ref='${refNo}']`);
  if (nodes?.length) {
    nodes[0]?.scrollIntoView?.({ block: 'center', inline: 'center' });
  }
  nodes.forEach((node) => {
    node.classList.add('CitationMarkerStyle_Burst');
  });
  setTimeout(
    () =>
      nodes.forEach((node) => {
        node.classList.remove('CitationMarkerStyle_Burst');
      }),
    2000
  );
}
export function removeCitationRefNodes(refNo: string) {
  const nodes = document.querySelectorAll(`[data-ref='${refNo}']`);

  nodes.forEach((node) => {
    node.parentNode?.removeChild(node);
  });
}

export function replaceCitationNode(
  refNo: string,
  text: string,
  citationStyle: CitationStylesEnum | string
) {
  // TODO: Verify -- this function may not be required
  const nodes = document.querySelectorAll(`[data-ref='${refNo}']`);
  nodes.forEach((node) => {
    node.classList.remove(
      'CitationMarkerStyle--MLA',
      'CitationMarkerStyle--APA',
      'CitationMarkerStyle--CHICAGO'
    );
    node.classList.add(`CitationMarkerStyle--${citationStyle}`);
    node.textContent = text;
  });
}

export function addCitationMarkerAtSelectedCursorPosition(
  pos: number,
  citation: CitationData,
  citedData: CitedData
) {
  document.getSelection()?.collapseToEnd();
  QuillEditor.getInstance(QuillEditorIDS.RESEARCH_EDITOR)?.appendHTML(
    `&nbsp;${getCitationRefNode(citation, citedData)}&nbsp;`
  );
}

export function updateCitationMarkerForThisCitation(citation: CitationData, citedData?: CitedData) {
  const nodes = document.querySelectorAll(`[data-ref='${citation.refId}']`);
  nodes?.forEach?.((n) => {
    const node = n as HTMLElement;

    // removing class which was applied from setupTempLoadersForCitations function
    node.classList.remove('dataRefHidden');

    if (citedData) {
      if (node?.parentElement?.getAttribute('title')) {
        node?.parentElement?.setAttribute(
          'title',
          citedData.full.map((previewObject) => previewObject.text).join('')
        );
      }
      node.innerHTML = citationsRichText([citedData], 'short', false);
    } else {
      console.error('Generated citation not found for citation:', citation.publicationInfo.title);
    }
  });
}
